import { useCallback, useEffect, useRef, useState } from 'react';
import { getChoferes, getTerminalesMP } from '../services/posnetsChoferesService';

// Carga en paralelo los choferes de la empresa (BD) y sus terminales (MP).
// Si falla MP, los choferes se muestran igual con un aviso.
export default function usePosnetsChoferes(empresaConfig) {
  const [choferes, setChoferes] = useState([]);
  const [terminales, setTerminales] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [errorTerminales, setErrorTerminales] = useState(null);
  const requestIdRef = useRef(0);

  const fetchDatos = useCallback(async () => {
    const requestId = ++requestIdRef.current;
    setLoading(true);
    setError(null);
    setErrorTerminales(null);

    const [resChoferes, resTerminales] = await Promise.allSettled([
      getChoferes(empresaConfig.id),
      getTerminalesMP(empresaConfig.apiBaseUrl),
    ]);

    if (requestId !== requestIdRef.current) return;

    if (resChoferes.status === 'fulfilled') {
      setChoferes(Array.isArray(resChoferes.value) ? resChoferes.value : []);
    } else {
      setChoferes([]);
      setError(resChoferes.reason?.message || 'Error al obtener los choferes');
    }

    if (resTerminales.status === 'fulfilled') {
      setTerminales(resTerminales.value);
    } else {
      setTerminales([]);
      setErrorTerminales(resTerminales.reason?.message || 'Error al obtener las terminales de Mercado Pago');
    }

    setLoading(false);
  }, [empresaConfig]);

  useEffect(() => {
    fetchDatos();
  }, [fetchDatos]);

  return { choferes, terminales, loading, error, errorTerminales, refetch: fetchDatos };
}
